import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Labels } from '@3ddv/ngx-sites-builder-lib';
import { ToolsService } from '../services/tools.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sbeditor-tool-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.scss']
})
export class LabelsComponent implements OnInit {
  private subscriptions: Array<Subscription>;
  public tool: Labels;
  @Output() exportTool = new EventEmitter<Labels>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.labels){
        this.tool = JSON.parse(JSON.stringify(res.labels));
      }else{
        console.error("labels tool not found");
        return;
      }
    });
    this.subscriptions.push(tools$);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }
  
  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

  public getTool(){
    return this.tool;
  }

  
}
